import React from 'react'
import { reduxForm } from 'redux-form'

import PreferencesForm from './PreferencesForm'
import { analytics } from '@src/services/Analytics'

const validate = (values) => {
  const errors = {}
  return errors
}

const collectAnalytics = (data) => {
  const getKeyNamesOfTrueProps = obj => Object.keys(obj).filter(key => obj[key])
  const {
    skills,
    preferences,
    estimatedHours
  } = data

  const eventData = {
    skills: getKeyNamesOfTrueProps(skills),
    preferences: getKeyNamesOfTrueProps(preferences),
    estimatedHours
  }

  analytics.preferencesSubmit(eventData)
}

export default function (props) {
  const {
    initialValues,
    onSubmit
  } = props

  initialValues.estimatedHours = calculateEstimatedHours(initialValues)

  const handleSubmit = (data) => {
    collectAnalytics(data)
    onSubmit(data)
  }

  const Form = reduxForm({
    form: 'booking',
    initialValues,
    validate,
    onSubmit: handleSubmit
  })(PreferencesForm)

  return <Form />
}

function calculateEstimatedHours (serviceSetup) {
  const betweenValues = (min, max) => (value) => {
    if (value < min) { return min }
    if (value > max) { return max }
    return value
  }

  const MIN_HOURS = 4
  const MAX_HOURS = 8

  const ROOM_HOUR_WEIGHT = 0.75
  const BATHROOM_HOUR_WEIGHT = 0.50
  const DESK_HOUR_WEIGHT = 0.25

  const {
    rooms,
    bathrooms,
    desks,
    preferences: {
      offices
    },
    estimatedHours
  } = serviceSetup

  if (estimatedHours >= 0) {
    return estimatedHours
  }

  const roomHours = rooms * ROOM_HOUR_WEIGHT
  const bathroomsHours = bathrooms * BATHROOM_HOUR_WEIGHT
  const deskHours = desks * DESK_HOUR_WEIGHT

  const suggestedHours = Math.ceil(offices ? deskHours * bathroomsHours : roomHours * bathroomsHours)
  const betweenThreeAndEight = betweenValues(MIN_HOURS, MAX_HOURS)
  return betweenThreeAndEight(suggestedHours)
}



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/PreferencesForm/PreferencesFormContainer.js